import { PurchaseBuyItemSx } from '@/components/blocks/FreeGiftV2/styles/freeGift';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { Badge, Box, useTheme } from '@mui/material';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

interface PurchaseBuyItemProps {
	quantity: number;
}

export const PurchaseBuyItem = ({ quantity }: PurchaseBuyItemProps) => {
	const theme = useTheme();

	const icon = (
		<DynamicIcon
			name={MATERIAL_SYMBOL_ICONS.box}
			color={theme.palette.grey[200]}
			size={'30px'}
			variant="rounded"
		/>
	);

	let content = icon;

	if (quantity > 1) {
		content = (
			<Badge
				badgeContent={quantity}
				color="success"
				overlap="circular"
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				sx={PurchaseBuyItemSx.badge}
			>
				{icon}
			</Badge>
		);
	}

	return <Box sx={PurchaseBuyItemSx.container}>{content}</Box>;
};
